import React from 'react';
import { IQuickFilterContext } from 'framework/IQuickFilterContext';
import { ITableViewContext } from 'framework/table/ITableViewContext';
import { IInventoryItem } from 'gen/ApiClient';
import { QuickFilter } from '../InventoryItemsList';
import { SelectableColumn } from '../SelectableColumn';

interface IViewContext extends ITableViewContext<SelectableColumn, IInventoryItem>, IQuickFilterContext<QuickFilter> {}

export const ViewContext = React.createContext<IViewContext>(undefined as any);
